export enum RIGHT_GRANTS {
    View = 0,
    Add = 1,
    Edit = 2,
    Delete = 3,
    Admin = 20,
}

export const RIGHT_LEVELS : Record<string, number> = {
    'View': RIGHT_GRANTS.View,
    'Add': RIGHT_GRANTS.Add,
    'Edit': RIGHT_GRANTS.Edit,
    'Delete': RIGHT_GRANTS.Delete,
    'Admin': RIGHT_GRANTS.Admin,
};

export const RIGHT_GRANT_LEVELS : Array<{ label : string; value : number }> = [
    { label: 'View', value: RIGHT_GRANTS.View },
    { label: 'Add', value: RIGHT_GRANTS.Add },
    { label: 'Edit', value: RIGHT_GRANTS.Edit },
    { label: 'Delete', value: RIGHT_GRANTS.Delete },
    { label: 'Admin', value: RIGHT_GRANTS.Admin },
];

export enum TRANSACTION_STATUS {
    Draft = 'Draft',
    Batching = 'Batching',
    Approved = 'Approved',
    Extracted = 'Extracted',
    Rejected = 'Rejected',
}

export const PAYMENT_TRANSACTION_STATUSES_OPTIONS : Array<{ label : string; value : number }> = [
    { label: TRANSACTION_STATUS.Draft, value: 0 },
    { label: TRANSACTION_STATUS.Batching, value: 1 },
    { label: TRANSACTION_STATUS.Approved, value: 2 },
    { label: TRANSACTION_STATUS.Extracted, value: 3 },
    { label: TRANSACTION_STATUS.Rejected, value: 4 },
];

export const BATCH_STATUSES_ORDER : Record<string, number> = {
    'Draft': 0,
    'Batching': 1,
    'Approved': 2,
    'Extracted': 3,
    'Rejected': 4,
};

// Always use white space between date and time.
export const DATE_FORMAT_DEFAULT_NO_SECONDS = 'DD/MM/YYYY HH:mm';
export const DATE_FORMAT_DEFAULT = 'DD/MM/YYYY HH:mm:ss';
export const DATE_FORMAT_DEFAULT_NO_TIME = 'DD/MM/YYYY';
export const DATE_FORMAT_NO_SECONDS = 'YYYYMMDD HH:mm';
export const DATE_FORMAT_SUMMARY = 'DD-MM-YYYY';

export const MAP_CENTER_POSITION : { lat : number; long : number } = {
    lat: -23.5792,
    long: 30.1424,
};

/*ZZFresh service */

export enum FreshServicePriority {
    Low = 1,
    Medium,
    High,
    Urgent,
}

export enum FreshServiceSourceType {
    Email = 1,
    Portal,
    Phone,
    Chat,
    FeedbackWidget,
    Yammer,
    AwsCloudwatch,
    PagerDuty,
    Walkup,
    Slack,
}

export enum FreshServiceStatus {
    Open = 2,
    Pending,
    Resolved,
    Closed,
}

/* Auth Types */

export enum AUTH_TYPES {
    Bearer = 'Bearer',
    APIKey = 'APIKey',
    Basic = 'Basic',
}

export const AUTH_TYPE_OPTIONS : Array<{ label : string; value : number }> = [
    { label: AUTH_TYPES.Bearer, value: 0 },
    { label: AUTH_TYPES.APIKey, value: 1 },
    { label: AUTH_TYPES.Basic, value: 2 },
];

export enum PAYLOAD_TYPES {
    Object = 'Object',
    ObjectList = 'Object List',
}

export const PAYLOAD_TYPE_OPTIONS : Array<{ label : string; value : number }> = [
    { label: PAYLOAD_TYPES.Object, value: 0 },
    { label: PAYLOAD_TYPES.ObjectList, value: 1 },
];

// This guid is the same for QA and Prod.
export const TOMATO_COMMODITY_GUID = 'a0c25ebf-a96d-11e9-8c18-42010a840098';
export const PEPPER_COMMODITY_GUID = '57d9cf54-477a-4780-8dd9-908f3719088e';
